import React from "react";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";

const QuantityInput = ({ inputRef, onChange, value, ...rest }) => (
  <NumericFormat
    {...rest}
    value={value || ""}
    getInputRef={inputRef}
    onValueChange={(values) => onChange(values.value)}
    decimalScale={0}
    allowNegative={false}
  />
);

QuantityInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default QuantityInput;
